export const TAGS_MAX_QUANTITY = 20;
export const MAX_TAG_LENGTH = 20;
